module.exports = __webpack_public_path__ + "images/emoji/white_square_button.9c31cdcedd7a8954c73e.png";